export default "__VITE_ASSET__B6Ng4DWT__"